import { router } from "@smakecloud/api-client-helper";
import { BasicSettingsLocales } from "./locales";
import { put } from "./put";
import { BasicSettingsTimezones } from "./timezones";
import { BasicSettingsWorkflows } from "./workflows";

export const basicSettings = router({
    locales: BasicSettingsLocales,
    put,
    timezones: BasicSettingsTimezones,
    workflows: BasicSettingsWorkflows,
});
